export const styles = {
	tableWrapper: {
		overflowX: 'auto',
	},
};

export default styles;
